import React, { useState, useEffect } from 'react';

import { APIROOT } from '../../Helpers/configs';

import { defineTicketNumberV3, handleClose } from '../../Helpers/helpers';

import {
  Box,
  Grid,
  Typography,
  TextField,
  Button,
  Divider,
  Modal,
} from '@mui/material';

import { ticketTypoInfo, ticketTypoTitle } from '../shared/commonStyle';
import RepairHistoryView from './RepairHistoryView';
import InstallHistoryView from './InstalHistoryView';

function SerialTicketHistoryView(props) {
  const ticketType = props.ticketInfo.ticket_type;
  const ticketNumber = props.ticketInfo.ticket_id;
  const closeModel = props.closeModel;

  const [ticketData, setTicketData] = useState([]);
  console.log(ticketData);

  async function getTicket() {
    let JWT = localStorage.getItem('JWT_Key');
    let headers = {
      'content-type': 'application/JSON',
    };

    if (JWT) {
      headers['x-api-key'] = JWT;
    }

    let body = {};
    const request = new Request(
      `${APIROOT}/api/r2_${ticketType}_tickets/${ticketNumber}`,
      {
        method: 'post',
        headers,
        body: JSON.stringify(body),
      }
    );

    const response = await fetch(request);

    const data = response.json();
    return data;
  }

  useEffect(() => {
    getTicket().then((data) => {
      // console.log(data);
      setTicketData(data.data.value);
    });
  }, []);

  return (
    <Box
      style={{
        minHeight: '20vh',
        maxWidth: '100%',
        maxHeight: '80vh',
        textAlign: 'left',
        border: 'solid 2px #354775',
        background: '#ebedf8',
        borderRadius: '5px',
        overflow: 'scroll',
      }}
      // sx={{scrollbar}}
    >
      {ticketType === 'repair' ? (
        <RepairHistoryView
          repair_ticket={ticketData?.repair_ticket ?? ticketData.repair_ticket}
          close={() => closeModel()}
        />
      ) : (
        <InstallHistoryView
          install_ticket={
            ticketData?.install_ticket ?? ticketData.install_ticket
          }
          close={() => closeModel()}
        />
      )}
    </Box>
  );
}

export default SerialTicketHistoryView;
